import React from 'react';

import styles from './CareTeamCTA.module.scss';

import commentIcon from '../../public/images/navy-comment.svg';

const {
  'care-team-cta': careTeamCTAClass,
  'cta-container': ctaContainerClass,
  'speech-bubble-icon': speechBubbleIconClass,
  'cta-text-container': ctaTextContainerClass,
  'cta-text': ctaTextClass
} = styles;

const CareTeamCTA = () => {
  return (
    <div className={careTeamCTAClass}>
      <div className={ctaContainerClass}>
        <div className={speechBubbleIconClass}>
          <img src={commentIcon} />
        </div>
        <div className={ctaTextContainerClass}>
          <div className={ctaTextClass}>
            <h5>Talk to our care team</h5>
            <p>
              Our team of experts is always here to guide you through the process and answer any
              questions.
            </p>
          </div>
          <a href="#" className="intercom-chat" href="mailto:wdj13bk6@intercom-mail.com">
            Get in touch today &gt;
          </a>
        </div>
      </div>
    </div>
  );
};

export default CareTeamCTA;
